import React from 'react'
import Image from 'next/image'
import { NewsItem } from '@/redux/services/newsApi'
import { newsStats } from '@/assets/data/news'
import Link from 'next/link'
import StatsComponent from '../StatsComponent'
import { useSelector } from 'react-redux'
import { RootState } from '@/redux/store'

interface Props {
    card: NewsItem
}

const NewsCard: React.FC<Props> = ({ card }) => {
    const { newsFilterTags } = useSelector((state: RootState) => state.filter)

    const tags = card.tags_id

    const matchingTags = tags.filter((tag) => newsFilterTags.includes(tag.id));

    return (
        <li
            key={card.id}
            className='news__card'
        >
            <Link href={`/news/${card.translit}`}>
                <div className='news__card-img'>
                    <Image src={`${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${card.intro}`} width={356} height={220} alt='news-image' />
                </div>
                <ul className='news__tags news__card-tags'>

                    {matchingTags.length ?
                        matchingTags.length < 2 ?
                            <>
                                {matchingTags.slice(0, 1)?.map((tag) => (
                                    <li
                                        key={tag.id}
                                        className='news__tag'
                                    >
                                        {tag.title}
                                    </li>
                                ))}
                                {tags.filter((tag) => tag.id !== newsFilterTags[0]).slice(0, 1)?.map((tag) => (
                                    <li
                                        key={tag.id}
                                        className='news__tag'
                                    >
                                        {tag.title}
                                    </li>
                                ))}
                            </>
                            :
                            matchingTags.slice(0, 2)?.map((tag) => (
                                <li
                                    key={tag.id}
                                    className='news__tag'
                                >
                                    {tag.title}
                                </li>
                            ))
                        :
                        tags.slice(0, 2)?.map((tag) => (
                            <li
                                key={tag.id}
                                className='news__tag'
                            >
                                {tag.title}
                            </li>
                        ))
                    }

                    <li className='news__tag-date'>
                        {/* {card.creation_date.slice(0, 10)} */}
                        {card.creation_date?.split('T')[0].split('-')[2]}.
                        {card.creation_date?.split('T')[0].split('-')[1]}.
                        {card.creation_date?.split('T')[0].split('-')[0]}
                    </li>
                </ul>
                <h3 className='news__title'>{card.title}</h3>
                <p className='news__description news__card-description'>{card.subtitle}</p>
                {/* <div className='stats'>
                    <div>
                        <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 17C14.6823 17 18.0156 14.8326 21 10.5C18.0146 6.16736 14.6823 4 11 4C7.31769 4 3.98435 6.16632 1 10.5C3.98538 14.8326 7.31769 17 11 17Z" stroke="#A9B4D1" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                            <circle cx="11" cy="10" r="3.2" stroke="#A9B4D1" strokeWidth="1.6" />
                        </svg>
                        <p>{card.views}</p>
                    </div>
                    <div>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 5.06897C4 4.52024 4.24082 3.99399 4.66947 3.60599C5.09812 3.21798 5.67951 3 6.28571 3H13.7143C14.3205 3 14.9019 3.21798 15.3305 3.60599C15.7592 3.99399 16 4.52024 16 5.06897V18L10 13.3448L4 18V5.06897Z" stroke="#A9B4D1" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <p>17</p>
                    </div>
                    <div>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.75 10.25L10 17.5L17.25 10.25C18.7688 8.73122 18.7688 6.26878 17.25 4.75C15.7312 3.23122 13.2688 3.23122 11.75 4.75L10 6.5L8.25 4.75C6.73122 3.23122 4.26878 3.23122 2.75 4.75C1.23122 6.26878 1.23121 8.73121 2.75 10.25Z" stroke="#A9B4D1" strokeWidth="1.6" />
                        </svg>
                        <p>17</p>
                    </div>
                </div> */}
                <StatsComponent likes={card.likes} views={card.views} />
            </Link>
        </li>
    )
}

export default NewsCard
